import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Product item type
export interface ProductItems {
  id: string;
  [key: string]: any;
}

// API response shape
interface ProductListResponse {
  productItems: ProductItems[];
  total: number;
  page: number;
  totalPages: number;
}

// Slice state
interface ProductState {
  data: ProductListResponse | null;
  loading: boolean;
  error: string | null;
}

// Update payload
export interface ProductUpdatePayload {
  id: string;
  [key: string]: any;
}

const initialState: ProductState = {
  data: null,
  loading: false,
  error: null,
};

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    setProductList(state, action: PayloadAction<ProductListResponse>) {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },

    addProduct(state, action: PayloadAction<ProductItems>) {
      const newProduct = action.payload;

      if (state.data) {
        state?.data?.productItems?.unshift(newProduct);
        state.data.total += 1;

        // keep pagination consistent
        if (state.data.productItems.length > 10) {
          state?.data?.productItems?.pop();
        }
      } else {
        state.data = {
          productItems: [newProduct],
          total: 1,
          page: 1,
          totalPages: 1,
        };
      }
    },

    productUpdate(state, action: PayloadAction<ProductUpdatePayload>) {
      const { id, ...updates } = action.payload;
      if (!state.data?.productItems) return;

      const product = state.data.productItems.find((p) => p.id === id);
      if (product) {
        Object.assign(product, updates);
      }
    },

    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const {
  setProductList,
  addProduct,
  productUpdate,
  setLoading,
  setError,
} = productSlice.actions;

export default productSlice.reducer;
